import React, { useEffect, useState } from "react";

import { useLoader } from "../../context/LoaderContext";
import "../../styles/LinkExpired.css";
import { Col, Row } from "antd";
import { maskingUtil } from "../../utils/maskingUtil";
import { getAuthMemberData } from "../../utils/authStorage";

const LinkExpired = () => {
  const { setLoading } = useLoader();
  const [emailId, setEmailId] = useState("");

  useEffect(() => {
    setLoading(false);
  }, [setLoading]);

  useEffect(() => {
    const fetchUser = async () => {
      const user = await getAuthMemberData(); // await async call
      // console.log("new user data", user);
      setEmailId(user?.email);
    };
    fetchUser();
  }, []);

  return (
    <>
      <div className="image-wrapper">
        <img src="/link_expired.png" alt="Centered" className="center-image" height={200} />
        <br />
      </div>
      <br />

      <Row justify="center">
        <Col>
          <div className="link-expired-title">Uh oh! This link has expired</div>

          <div className="link-expired-sub-title">A new link has been shared with you over email ({maskingUtil("email", emailId)}).</div>
        </Col>
      </Row>

      <br />
    </>
  );
};

export default LinkExpired;
